import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=451d73dd&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=451d73dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451d73dd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('451d73dd')) {
      api.createRecord('451d73dd', component.options)
    } else {
      api.reload('451d73dd', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=451d73dd&scoped=true&", function () {
      api.rerender('451d73dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ssKSWzTkXB0M/JS/teamMember.vue"
export default component.exports